import { uiCapabilityGrantedByRoles } from "@/helpers/capabilities";
import store from "@/store/store";

// TKP-97: rota kuralları da adlandırılmış arayüz yeteneğiyle sorar (`helpers/capabilities.js`).
export function hasCapability(capability) {
  const organization = store.getters["organization/selected"];
  const account = store.getters["user/account"];

  if (!organization || !account) {
    return false;
  }

  if (account._id == organization.createdBy?._id) {
    return true;
  }
  // TKP-98: düz yetki listesi yerine ROLLER — güvenlik kapısı rolün katalog anahtarına bakıyor.
  return uiCapabilityGrantedByRoles(organization.roles, capability);
}

export function createRule(fnc, redirect = -1) {
  return (routeTo, routeFrom) => {
    return {
      redirect: typeof redirect === "function" ? redirect(routeTo, routeFrom) : redirect,
      rule() {
        return fnc(routeTo, routeFrom);
      },
    };
  };
}

export function canOrganizationAccessProduct(product) {
  const organization = store.getters["organization/selected"];
  return organization?.features?.accessableProducts?.includes(product);
}

// Generic Rules

export const isLoggedIn = createRule(
  (routeTo, routeFrom) => {
    return !!store.getters["user/jwt"];
  },
  (routeTo, routeFrom) => {
    return routeTo.path ? "/login?redirectUrl=" + routeTo.path : "/login";
  }
);

//
//
export const isNotLoggedIn = createRule(() => {
  return !store.getters["user/jwt"];
});
export const isOrganizationSelected = createRule(() => !!store.getters["organization/selected"], "/403");

export const isAccountTypeSystem = createRule(() => store.getters["user/account"]?.type == "system", "/");
export const isAdminOrOwnerOfAnyWorkpace = createRule(() => !!store.getters["user/isAdminOrOwnerOfAnyWorkpace"], "/");

/** TKP-143: çalışma alanı alt ekranları (organizasyonlar/üyeler/kütüphane) seçili çalışma alanı ister; yoksa listeye dön. */
export const isWorkspaceSelected = createRule(() => !!store.getters["switchWorkspace/selected"]?._id, "/workspace");

export const isAdminOfDepartmentOrProcess = createRule(() => !!store.getters["user/account"]?.adminEntities?.isDepartmentOrProcessAdmin, "/");

export const isOrganizationAdmin = createRule(() => hasCapability("ROUTE_AUTHORIZATION__IS_ORGANIZATION_ADMIN"));
export const isWorkspaceAdmin = createRule(() => {
  const selectedWorkspace = store.getters["switchWorkspace/selected"];
  if (!selectedWorkspace) {
    return false;
  }

  const account = store.getters["user/account"];

  return selectedWorkspace.owner._id == account._id || selectedWorkspace.role?.definition == "WORKSPACE_ADMIN";
}, "/403");

export const canGetOrganizationSettingsPage = createRule(() =>
  hasCapability("ROUTE_AUTHORIZATION__CAN_GET_ORGANIZATION_SETTINGS_PAGE")
);

export const canGetGdprFileManagerPage = createRule(
  () =>
    canOrganizationAccessProduct("GDPR") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_GDPR_FILE_MANAGER_PAGE")
);

export const canGetKvkkFileManagerPage = createRule(
  () =>
    canOrganizationAccessProduct("KVKK") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_KVKK_FILE_MANAGER_PAGE")
);

export const canGetDDOFileManagerPage = createRule(
  () =>
    canOrganizationAccessProduct("DDO") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_DDOFILE_MANAGER_PAGE")
);

// TKP-150: organizasyon paneli ekran kapıları (menüyle aynı yetenekler)
export const canGetOrganizationHierarchyPage = createRule(() => hasCapability("ORGANIZATION_SIDE_BAR__HAS_HIERARCHY_PERMISSION"));
export const canGetOrganizationAssetGroupsPage = createRule(() => hasCapability("ORGANIZATION_SIDE_BAR__HAS_ASSET_GROUP_PERMISSION"));
export const canGetOrganizationThirdPartyPage = createRule(() => hasCapability("ORGANIZATION_SIDE_BAR__HAS_THIRD_PARTY_PERMISSION"));
export const canGetOrganizationFileManagerPage = createRule(() => hasCapability("ORGANIZATION_SIDE_BAR__HAS_FILE_MANAGER_PERMISSION"));

export const canGetRiskDecisionPage = createRule(() => hasCapability("ROUTE_AUTHORIZATION__CAN_GET_RISK_DECISION_PAGE"));

// TKP-118 / tasarım s.24 md.1 ve md.6 — Görevler ayrı modül; ekran TASKS modülüne göre açılıp kapanıyor.
// TKP-87 kararı: TASKS satılabilir MODÜL, uyum ürünü değil; bu yüzden ürün katmanı yeteneği değil doğrudan modül erişimi sorulur.
export const canAccessTasksModule = createRule(() => canOrganizationAccessProduct("TASKS"), "/403");

export const canGetGdprLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("GDPR") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_GDPR_LAYOUT_PAGES")
);

export const canGetKvkkLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("KVKK") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_KVKK_LAYOUT_PAGES")
);

export const canGetDdoLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("DDO") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_DDO_LAYOUT_PAGES")
);

export const canGetBgysLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("BGYS") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_BGYS_LAYOUT_PAGES")
);

export const canGetRiskLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("RISK") &&
    hasCapability("ROUTE_AUTHORIZATION__CAN_GET_RISK_LAYOUT_PAGES")
);
